import { render } from "./Collaborators.vue?vue&type=template&id=5556c5b6&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=5556c5b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5556c5b6"]])

export default __exports__